import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const TopSellers = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const products = [
  { id: 1, name: "ORAL ANABOLICS", icon: "💊", color: "bg-amber-50" },
  { id: 2, name: "SUPPLEMENTS", icon: "🫙", color: "bg-emerald-50" },
  { id: 4, name: "INJECTABLES", icon: "💉", color: "bg-orange-50" },
];


  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section with Animation */}
        <div className="text-center md:text-left mb-12 md:mb-16">
          <div className={`transform transition-all duration-700 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
          }`}>
            <span className="inline-block px-4 py-2 rounded-full bg-red-50 text-red-600 text-xs font-semibold tracking-wider mb-4">
              🔥 HOT THIS MONTH
            </span>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
              <span className="bg-gradient-to-r from-gray-900 to-gray-600 bg-clip-text text-transparent">
                TOP 10
              </span>{" "}
              <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
                BEST SELLERS
              </span>
            </h2>
            
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto md:mx-0">
              Discover our most popular supplements trusted by thousands of fitness enthusiasts worldwide
            </p>
          </div>
        </div>

        {/* Main Content Grid */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          
          {/* Product List Section */}
          <div className={`transform transition-all duration-700 delay-200 ${
            isVisible ? 'translate-x-0 opacity-100' : '-translate-x-10 opacity-0'
          }`}>
            <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-8">
              <div className="flex items-center justify-between mb-8">
                <h3 className="text-xl sm:text-2xl font-bold text-gray-900">
                  Best Selling Products
                </h3>
                <span className="text-sm text-gray-500">
                  {products.length} categories
                </span>
              </div>

              <div className="space-y-4">
                {products.map((product, index) => (
                  <Link
                    key={product.id}
                    to={`/category/${product.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="group block"
                  >
                    <div className={`flex items-center justify-between p-4 rounded-xl transition-all duration-300 hover:shadow-md ${
                      product.color
                    } hover:scale-[1.02]`}>
                      <div className="flex items-center gap-4">
                        <span className="text-2xl">{product.icon}</span>
                        <div>
                          <p className="font-semibold text-gray-900 group-hover:text-red-600 transition-colors">
                            {product.name}
                          </p>
                          <p className="text-sm text-gray-500">
                            Shop now →
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="text-sm font-medium text-red-600 bg-red-50 px-3 py-1 rounded-full">
                          #{index + 1}
                        </span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>

              <Link
                to="/shop"
                className="group mt-8 w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-gradient-to-r from-gray-900 to-gray-800 text-white text-sm font-semibold rounded-xl hover:from-red-600 hover:to-red-500 transition-all duration-300 hover:shadow-lg hover:shadow-red-100"
              >
                <span>VIEW ALL PRODUCTS</span>
                <span className="group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            </div>
          </div>

          {/* Product Image Section */}
          <div className={`relative transform transition-all duration-700 delay-400 ${
            isVisible ? 'translate-x-0 opacity-100' : 'translate-x-10 opacity-0'
          }`}>
            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-32 h-32 bg-red-100 rounded-full opacity-30 blur-2xl"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-amber-100 rounded-full opacity-30 blur-2xl"></div>
            
            {/* Main Image Container */}
            <div className="relative bg-gradient-to-br from-red-50 to-amber-50 rounded-3xl p-8 shadow-2xl">
              {/* Badge */}
              <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-lg z-10">
                <span className="text-sm font-bold text-gray-900">
                  ⭐ Bestseller
                </span>
              </div>

              {/* Image */}
              <img
                src="/assets/supplements/eca-burn.jpeg"
                alt="DNP Burn - Best Selling Supplement"
                className="w-full max-h-[400px] md:max-h-[500px] object-contain drop-shadow-2xl transform hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />

              {/* Stats Overlay */}
              <div className="absolute bottom-4 left-4 right-4 bg-white/90 backdrop-blur-sm rounded-xl p-4 shadow-lg">
                <div className="grid grid-cols-3 gap-2 text-center">
                  <div>
                    <p className="text-xs text-gray-500">Rating</p>
                    <p className="font-bold text-gray-900">4.8/5</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Sold</p>
                    <p className="font-bold text-gray-900">10k+</p>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Reviews</p>
                    <p className="font-bold text-gray-900">2.5k</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Floating Cards (Decorative) */}
            <div className="hidden lg:block absolute -bottom-6 -left-6 w-24 h-24 bg-white rounded-2xl shadow-xl p-4 animate-bounce-slow">
              <span className="text-3xl">💪</span>
            </div>
            <div className="hidden lg:block absolute -top-6 -right-6 w-20 h-20 bg-white rounded-2xl shadow-xl p-3 animate-bounce-slow animation-delay-200">
              <span className="text-2xl">⚡</span>
            </div>
          </div>
        </div>

        {/* Trust Badges */}
        <div className={`mt-16 flex flex-wrap justify-center gap-6 md:gap-12 transform transition-all duration-700 delay-600 ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'
        }`}>
          {[
            { icon: "✓", text: "100% Authentic" },
            { icon: "🚚", text: "Free Shipping" },
          ].map((badge, i) => (
            <div key={i} className="flex items-center gap-2 text-gray-600">
              <span className="text-red-600 font-bold">{badge.icon}</span>
              <span className="text-sm font-medium">{badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopSellers;